import { useMemo } from "react";
import { AgGridReact } from "@jsq/ds/core";
import { useFeatureFlag } from "@jsq/flags-react";
import { DashboardCell } from "~/pages/Dashboard/components/WorkspaceTable/CellComponents";
import { BulkArenaAccessCell } from "../CellComponents/BulkArenaAccessCell";

export const useUserTableConfiguration = () => {
  const isBulkArenaAccessEnabled = useFeatureFlag("faBulkArenaAccess", false);
  const columnDefs: AgGridReact.AgGridReactProps["columnDefs"] = useMemo(() => {
    return [
      {
        field: "id",
        headerName: "User ID",
        cellRenderer: DashboardCell,
        filter: "agNumberColumnFilter",
        checkboxSelection: true,
        headerCheckboxSelection: true,
      },
      {
        field: "name",
        headerName: "User",
        cellRenderer: DashboardCell,
        filter: "agTextColumnFilter",
      },
      {
        field: "email",
        headerName: "Email",
        cellRenderer: DashboardCell,
        filter: "agTextColumnFilter",
      },
      {
        field: "activeWorkspaces",
        headerName: "Active workspaces",
        cellRenderer: DashboardCell,
      },
      ...(isBulkArenaAccessEnabled
        ? [
            {
              field: "bulkArenaAccess",
              headerName: "Access to all client workspaces",
              cellRenderer: BulkArenaAccessCell,
              filter: "agSetColumnFilter",
              filterParams: {
                values: ["Yes", "No"],
              },
            },
          ]
        : []),
      { field: "lastAccessDate", headerName: "Last access", cellRenderer: DashboardCell },
    ];
  }, [isBulkArenaAccessEnabled]);
  return { columnDefs };
};
